export default "__VITE_ASSET__DzWy7xjv__"